import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const MEDICAL_CONDITIONS_QUERY_KEY = "hrMedicalConditionsData";

export const useMedicalConditionsQuery = (patientUserId) => {
  let queryKey = [MEDICAL_CONDITIONS_QUERY_KEY, patientUserId];
  return useQuery({
    queryKey: queryKey,
    queryFn: listMedicalCondition.bind(this, patientUserId, null),
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useMedicalConditionQuery = (patientUserId, medicalConditionId) => {
  let queryKey = [MEDICAL_CONDITIONS_QUERY_KEY, patientUserId];
  return useQuery({
    queryKey: queryKey,
    queryFn: listMedicalCondition.bind(this, patientUserId, medicalConditionId),
    placeholderData: [],
    enabled: !!medicalConditionId && !!patientUserId,
    select: (medicalConditions) => {
      const mc = medicalConditions?.filter(
        (m) => m.id === medicalConditionId
      )[0];
      if (mc) {
        return {
          ...mc,
          startDate: mc.startDate?.replace(/-/g, "/") ?? "",
        };
      }
      return null;
    },
  });
};

const listMedicalCondition = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "hrmedicalconditionapi",
    path: `/medical-conditions/${patientUserId}`,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return (await body?.json()) || [];
};
